import { Column } from '../../../common/interfaces';
import { ColumnType, FilterConditionOperators } from '../../../common/enums';

export enum FilterActionType {
    NEW_FILTER = 'newFilter',
    EDIT_FILTER = 'editFilter',
    DUPLICATE_FILTER = 'duplicateFilter',
}
export interface FilterCondition {
    columnId: string;
    columnType: string | undefined;
    operator: FilterConditionOperators | undefined;
    value?: any;
}

export interface Filter {
    id?: string;
    viewId?: string;
    name?: string;
    conditions: FilterCondition[];
    ownerUserId?: string | null;
    shared: boolean;
}

export interface FilterConditionUI extends FilterCondition {
    isValid: boolean;
    enableValue: boolean;
    isFieldValid: boolean;
    isDateType: boolean;
    isOperatorValid: boolean;
    isValueValid: boolean;
    doesFieldExist: boolean;
    conditionFields: Column[];
    conditionOperators: FilterConditionOperators[];
    columnType: ColumnType | undefined;
}

export interface FilterUI extends Filter {
    isValid: boolean;
    isFilterEmpty: boolean;
    disableAddCondition: boolean;
    disableDeleteCondition: boolean;
    conditions: FilterConditionUI[];
}
